import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8% 0px" }}
      transition={{ duration: 1, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </M>
  );
};

const lineVariants = {
  hidden: { y: "115%", rotate: 4 },
  show: (d) => ({ y: "0%", rotate: 0, transition: { duration: 1.15, ease: EASE, delay: d } }),
};

export const MaskLines = ({ lines, delay = 0, inView = false, stagger = 0.11, lineClassName }) => {
  const trigger = inView ? { whileInView: "show", viewport: { once: true, margin: "-10% 0px" } } : { animate: "show" };
  return (
    <motion.span className="block" initial="hidden" {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.14em] -mb-[0.14em]">
          <motion.span variants={lineVariants} custom={delay + i * stagger} className={`block origin-left ${lineClassName ? lineClassName(i) : ""}`}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Eyebrow = ({ children, className = "", testid }) => (
  <p data-testid={testid} className={`eyebrow flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-gradient-to-r from-[#22d3ee] to-[#5cf2a0]" />
    {children}
  </p>
);
